"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiRegister {
    static registerUser(body) {
        let url = "/VerifyRegisterUser";
        return Client_1.default.httpGCFPost(url, body);
    }
    static verifyDetails(body) {
        let url = `/UpdateUserEmail?action=verify`;
        return Client_1.default.httpGCFPost(url, body);
    }
    static changeUsername(body) {
        let url = `/UpdateUserEmail?action=change`;
        return Client_1.default.httpGCFPost(url, body);
    }
    static answerQuestion(body) {
        let url = `/UpdateUserEmail?action=challenge`;
        return Client_1.default.httpGCFPost(url, body);
    }
    static trustedDeviceTrust(token) {
        let url = "/VerifyTrustedDevice/trust";
        return Client_1.default.httpGCFPost(url, {}, { 'Authorization': `Bearer ${token}` });
    }
    static trustedDeviceVerify(token, body) {
        let url = "/VerifyTrustedDevice/verify";
        return Client_1.default.httpGCFPost(url, body, { 'Authorization': `Bearer ${token}` });
    }
}
exports.default = ApiRegister;
